import { render, staticRenderFns } from "./FormControlTagsUsageComponent.vue?vue&type=template&id=c31bfe8e&scoped=true"
import script from "./FormControlTagsUsageComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlTagsUsageComponent.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlTagsUsageComponent.vue?vue&type=style&index=0&id=c31bfe8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c31bfe8e",
  null
  
)

export default component.exports